import { View, ViewConstructor } from "../view";
import * as Dom from '../helpers/dom';
import { LazyTemplate } from "../template/index";

export default class ViewRendeder
{
        /**
     * Renders a view template to an HTML element.
     * @param html HTML string to be rendered with doT
     * @param view doT render context. If not provided, uses current view instead.
     */
    public static renderViewTemplate(renderFunction: doT.RenderFunction, viewContext: View | any): HTMLElement
    {
        let element =  Dom.createElement('div', {
            classNames: ['component'],
            innerHTML: renderFunction(viewContext)
        });

        if (element.children.length == 1)
        {
            return <HTMLElement>element.firstElementChild;
        }
        else
        {
            return element;
        }
    }

    /**
     * Resolves a view's template to doT.RenderFunction.
     * @param view View to resolve 
     */
    public static resolveViewTemplate(view: View): Promise<doT.RenderFunction>
    {
        return new Promise((resolve, reject) => 
        {
            (view.template as LazyTemplate)().then((renderFunction) => 
            {
                resolve(renderFunction);
            });
        });
    }

    /**
     * Resolves a view's template to an HTML Element.
     * @param view View to resolve
     */
    public static renderToElement(view: View): Promise<void>
    {
        return ViewRendeder.resolveViewTemplate(view).then((renderFunction) =>
        {
            view.element = ViewRendeder.renderViewTemplate(renderFunction, view);
        });
    }
}